import { Trans } from "@lingui/macro";
import { IApiEpBillingBill, IApiEpBillingPaymentProvider } from "@smp/api";
import { UiBox, UiButton, UiTypography } from "@smp/ui";
import { useCallback, useRef } from "react";

import { useWindowOpener } from "@/hooks/use_window_opener";

export const Qiwi = ({
  bill,
  onClose,
  onReachGoal,
  description = "",
  provider,
}: {
  bill: IApiEpBillingBill;
  onClose: () => void;
  onReachGoal: () => void;
  provider: IApiEpBillingPaymentProvider;
  description?: string;
}) => {
  const isGoalReached = useRef(false);
  const urlOrigin = window.location.origin;
  const urlFail = urlOrigin + "/honme/public/purchase/fail";
  const urlSuccess =
    urlOrigin + "/home/public/purchase/success?bill=" + bill.id;

  const publicId = provider.currencies_supported[bill.currency]?.public_id;

  const params = new URLSearchParams();
  publicId && params.set("from", publicId);
  params.set("summ", bill.amount);
  params.set("currency", bill.currency);
  params.set("comm", description);
  params.set("txn_id", bill.id.toString());
  params.set("successUrl", urlSuccess);
  params.set("failUrl", urlFail);

  const url = `https://w.qiwi.com/order/external/create.action?${params.toString()}`;

  const { isOpen, open } = useWindowOpener(
    { url },
    {
      onClose: () => {
        if (!isGoalReached.current) {
          onClose();
        }
      },
    },
  );

  const handleOpen = useCallback(() => {
    isGoalReached.current = true;
    onReachGoal();
    onClose();
    open();
  }, [onClose, onReachGoal, open]);

  return isOpen ? (
    <UiBox>
      <UiBox>
        <UiTypography>
          <Trans>The payment process is taking place in another window.</Trans>
        </UiTypography>
      </UiBox>
      <UiBox>
        <UiTypography>
          <Trans>Now you can close this dialog.</Trans>
        </UiTypography>
      </UiBox>
    </UiBox>
  ) : (
    <UiBox>
      <UiBox mb={2}>
        <UiTypography>
          <Trans>
            A payment invoice has been created, please proceed to payment.
          </Trans>
        </UiTypography>
      </UiBox>
      <UiBox>
        <UiButton color="primary" onClick={handleOpen} variant="contained">
          <Trans>Proceed</Trans>
        </UiButton>
      </UiBox>
    </UiBox>
  );
};
